export const API_point_imports_excel = (workspaceId: string): string =>
  `/api/v2/point-imports/excel/${workspaceId}`;
